import { connect } from 'react-redux';

import { fetchEvents, fetchEventsFilters } from 'client/ducks/events-page/actions';
import {
    isLoading,
    hasMoreEvents,
    getEvents,
    getEventsMeta,
    getFilterYears,
    getEventsParams
} from 'client/ducks/events-page/selectors';
import { State } from 'client/store';

import EventsListPage, { DispatchProps, Props } from './events-page';

function mapStateToProps(state: State): Partial<Props> {
    return {
        hasMore: hasMoreEvents(state),
        years: getFilterYears(state),
        rows: getEvents(state),
        meta: getEventsMeta(state),
        listParams: getEventsParams(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = {
    fetchEvents,
    fetchFilters: fetchEventsFilters
};

export default connect<Partial<Props>, DispatchProps>(mapStateToProps, mapDispatchToProps)(EventsListPage);
